"use client";

import { ArrowLeft, FileQuestion, Home } from "lucide-react";
import { useRouter } from "next/navigation";
import { PageContainer } from "@/components/scriba/ui/PageContainer";
import { Button } from "@/components/tailwind/ui/button";

export default function NotFoundPage() {
  const router = useRouter();

  return (
    <PageContainer className="flex items-center justify-center">
      <div className="text-center max-w-md mx-auto">
        <div className="mx-auto w-24 h-24 bg-gray-100 dark:bg-gray-800 rounded-full flex items-center justify-center mb-6">
          <FileQuestion className="h-12 w-12 text-gray-400" />
        </div>

        <h1 className="text-3xl font-bold text-gray-900 dark:text-white mb-2">Page Not Found</h1>

        <p className="text-gray-600 dark:text-gray-400 mb-8">
          The page you&apos;re looking for doesn&apos;t exist or has been moved.
        </p>

        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Button onClick={() => router.back()} variant="outline" className="flex items-center gap-2">
            <ArrowLeft className="h-4 w-4" />
            Go Back
          </Button>

          <Button
            onClick={() => router.push("/")}
            className="flex items-center gap-2 bg-gray-900 hover:bg-gray-800 dark:bg-white dark:hover:bg-gray-100 text-white dark:text-gray-900"
          >
            <Home className="h-4 w-4" />
            Home
          </Button>
        </div>
      </div>
    </PageContainer>
  );
}
